import React from 'react';
import _ from 'lodash-es';
import { connect } from 'react-redux';
import { Card, CardHeader, Layout, Description, Table, Alert, StatusMessage, TitleBar } from '../components/library-components';
import { getSubscriptionGroup, getAssetCategoriesCors, createOrUpdateSubscriptionPlan, destroySubscriptionPlan, getAccountSettings } from '../api';
import { SET_SUBSCRIPTION_GROUP, SET_ERRORS } from '../actions';
import currencyUtils from '../helpers/currencyUtils';
import TableRowWithActionDropdown from '../components/table-row-with-action-dropdown/table-row-with-action-dropdown';
import CustomSelect from '../components/coupons/custom-select/custom-select';
import PayPerAssetPlan from './pay_per_asset_plan';

const ACTIVE_INACTIVE = ['Active', 'Inactive'].map((k) => ({ label: k, value: k === 'Active' }));

export class PayPerAssetGroups extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showPlanDetails: false,
      showNotification: { isNotificationOpen: false, status: '', statusMessage: '' },
      showSave: false,
      payPerAssetEnabled: true
    };

    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount () {
    this.loadSubscriptionGroup();
    getAssetCategoriesCors(true).then(assetCategories => this.setState({ assetCategories: assetCategories }));
    this.setState({ errros: {} });
    getAccountSettings().then(response => {
      this.setState({ payPerAssetEnabled: response.account.pay_per_asset_enabled });
    });
  }

  loadSubscriptionGroup () {
    getSubscriptionGroup(this.props.groupId).then((response) => this.props.setSubscriptionGroup(response));
  }

  onSubscriptionPlanUpdate (errors) {
    if (errors) {
      return this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: errors.map((error, index) => <span key={index}>{error}</span>) } });
    }
    this.loadSubscriptionGroup();
    this.setState({ showPlanDetails: !this.state.showPlanDetails });
  }

  addNewPlan () {
    this.onEdit('new');
  }

  onEdit (planId) {
    this.setState({
      showPlanDetails: true,
      selectedPlanId: planId,
      showSave: false
    });

    this.props.setErrors({ errors: {} });
  }

  onCancel (plan) {
    this.setState({
      showPlanDetails: false
    });
  }

  onDelete (plan) {
    this.setState({ selectedPlan: plan, showDeleteConfirm: true });
  }

  onDeleteCancel () {
    this.setState({ selectedPlan: null, showDeleteConfirm: false });
  }

  onDeleteConfirm () {
    destroySubscriptionPlan(_.get(this.props.subscriptionGroup, ['id']), this.state.selectedPlan['id'])
      .then((response) => this.loadSubscriptionGroup())
      .catch(() => this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: 'Unable to delete plan, please try again or contact support@quintype.com' } }))
      .finally(() => this.setState({ showDeleteConfirm: false }));
  }

  onChangeStatus (selectedItem, index) {
    let selectedPlan = _.get(this.props.subscriptionGroup, ['subscription_plans', index]);
    selectedPlan = Object.assign({}, selectedPlan, { enabled: selectedItem });
    createOrUpdateSubscriptionPlan(_.get(this.props.subscriptionGroup, ['id']), selectedPlan).then((response) => {
      this.loadSubscriptionGroup();
    });
  }

  render () {
    const group =
      <Layout>
        <TitleBar title="Pay Per Asset Pricing" breadcrumbTitle='Home' breadcrumbPath='/' />
        <Card>
          {<CardHeader
            title='Asset Pricing'
            buttonText='Add'
            buttonOnClick={() => this.addNewPlan()}
            isButton={this.state.payPerAssetEnabled}
          />}
          { this.state.payPerAssetEnabled && <Description>
            Configure asset prices
          </Description>}

          { !this.state.payPerAssetEnabled && <Description>
            Pay per asset is not enabled for this account. Please contact support@quintype.com to enable this feature.
          </Description>}

          { this.state.showPlanDetails &&
            <PayPerAssetPlan
              subscriptionGroupId={this.props.subscriptionGroup.id}
              subscriptionPlanId={this.state.selectedPlanId}
              assetCategories={this.state.assetCategories}
              afterSave={(e) => this.onSubscriptionPlanUpdate(e)}
              onCancel={(e) => this.onCancel(e)}
            /> }

          <Table header={['Asset Type', 'Duration', 'Price', 'Status']} className='table-default--4cols'>
            { _.map(_.get(this.props.subscriptionGroup, ['subscription_plans']), (plan, index) => {
              const actionsForPlan = [{ action: 'Edit', actionHandler: this.onEdit, id: plan.id }, { action: 'Delete', actionHandler: this.onDelete, id: plan }];
              return <TableRowWithActionDropdown id={plan.id} dropdownActions={actionsForPlan} key={plan.id} showVerticalMenu={this.state.payPerAssetEnabled}>
                <div className='table-default__cell'>{_.get(plan, ['display_assets', '0', 'type'], '')} { !_.isEmpty(_.get(plan, ['display_assets', '0', 'metadata'])) && <div> belongs to collection with Id { _.get(plan, ['display_assets', '0', 'metadata', 'collection_id']) } </div> }</div>
                <div className='table-default__cell'>{plan.duration_length} {plan.duration_unit}</div>
                <div className='table-default__cell'>{plan.price_currency} {currencyUtils.convertToCurrencyUnits(plan.price_cents)}</div>
                <div className='table-default__cell'>
                  <CustomSelect
                    id={plan.id}
                    value={plan.enabled}
                    options={ACTIVE_INACTIVE}
                    onChangeActive={(selectedItem) => this.onChangeStatus(selectedItem, index)} />
                </div>
              </TableRowWithActionDropdown>;
            }) }
          </Table>
        </Card>
        {this.state.showNotification.isNotificationOpen &&
          <StatusMessage statusMessage={this.state.showNotification.statusMessage}
            status={this.state.showNotification.status}
            onCancel={() => this.setState({ showNotification: { isNotificationOpen: false, status: '', statusMessage: '' } })} />}
        {this.state.showDeleteConfirm && <Alert title='Delete Pay per Asset plan'
          open
          destructive
          onCancel={() => this.onDeleteCancel()}
          onConfirm={() => this.onDeleteConfirm()}>
            This action will delete the plan permanantly. Do you still want to continue?
        </Alert>}
      </Layout>;
    return (group);
  }
}

function mapStateToProps (state) {
  return {
    subscriptionGroup: state.subscriptionGroup || [],
    errors: state.errors || []
  };
}

function mapDispatchToProps (dispatch) {
  return {
    setSubscriptionGroup: (subscriptionGroup) => dispatch({ type: SET_SUBSCRIPTION_GROUP, subscriptionGroup: subscriptionGroup }),
    setErrors: (errors) => dispatch({ type: SET_ERRORS, errors: errors })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PayPerAssetGroups);
